(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('HubspotDealDialogController', HubspotDealDialogController);

    HubspotDealDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HubspotDeal', 'AppraisalOrder'];

    function HubspotDealDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HubspotDeal, AppraisalOrder) {
        var vm = this;

        vm.hubspotDeal = entity;
        vm.clear = clear;
        vm.save = save;
        vm.appraisalorders = AppraisalOrder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hubspotDeal.id !== null) {
                HubspotDeal.update(vm.hubspotDeal, onSaveSuccess, onSaveError);
            } else {
                HubspotDeal.save(vm.hubspotDeal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:hubspotDealUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
